import { render } from "./Changelog.vue?vue&type=template&id=67823235&ts=true"
import script from "./Changelog.vue?vue&type=script&lang=ts"
export * from "./Changelog.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Windows/Changelog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67823235"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67823235', __exports__)) {
    api.reload('67823235', __exports__)
  }
  
  module.hot.accept("./Changelog.vue?vue&type=template&id=67823235&ts=true", () => {
    api.rerender('67823235', render)
  })

}


export default __exports__